<template>
   <div class="update-bonus-content-element container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point6Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                      {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseUpdateElementOverlay($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                      {{lessonObj.Title}}
                  </div>    
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left orange-text-color create-element-overlay-course-title-font-styles">
                    Associated Bonus Content: {{prevLinkedbonusModuleName}}
                  </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  <!-- Index -->
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <!-- <input type="text" class="form-control" v-model="BonusIndexValue"> -->
                            <input type="text" class="form-control" v-model="BonusTitleValue" :maxlength="titleMaxLength">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Duration
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="BonusDurationValue" disabled>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Bonus Content
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="selectedBonusModuleId">
                        <option value=-1 disabled>Select</option>
                        <option v-for="bonusObj in getBonusModuleList" v-bind:key="bonusObj.ModuleId" v-bind:value="bonusObj.ModuleId">{{ bonusObj.Title }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-4">
                </div>  
                <div class="col-md-4 col-lg-4">
                  <!-- ToDo: Track this -->
                   <div class="col-lg-offset-3 col-md-8 col-lg-9">
                      <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateBonusContent">Update Bonus Content</button>
                   </div>
                   <div class="col-md-4 col-lg-1">

                   </div>
                </div>  
                <div class="col-md-5 col-lg-4">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div> 
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="openCreateBonusOverlay"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import { bonusService } from '@/server-util/bonus-service'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['lessonObj', 'isBonusModuleCreated', 'showAssociateMsg', 'ElementObj'],
  name: 'update-bonus-content-element',
  created () {
    // AK: If user declined creation of Bonus module (By closing Bonus module creation overlay) then don't invoke call again
    if (this.getIsBonusModuleCreated) {
      this.getBonusModules()
    }
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      bonusModuleList: [],
      elementObj: {
        ElementId: '',
        ModuleId: '',
        Title: '',
        Duration: '',
        BonusModuleId: -1,
        Index: null
      },
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      prevLinkedbonusModuleName: 'Not linked',
      titleMaxLength: constants.Element_Title_Step_Max_Length
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader
  },
  methods: {
    openCreateBonusOverlay (value) {
      // AK: if user pressed okay to crate Bonus module then show it
      this.showConfirmationBox = false
      if (value) {
        // AK: Close Create Bonus content overlay (Temporary)
        this.$emit('closeUpdateBonusContentOverlay', false)
        // AK: Show Create Bonus Module Overlay
        this.$emit('openBonusModuleCreationOverlay', true)
      }
    },
    getBonusModules: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
         // AK: Start showing spinner
        // _this.showSpinner = true
        _this.$store.state.isLoading = true

        bonusService.listNonAttachedBonusModules(storeObj.state.access_token, storeObj.state.selectedCourseObjFromFilter.CourseMasterId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              _this.bonusModuleList = responseObj.data
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(this.bonusModuleList))
              if (_this.bonusModuleList.length === 0) {
                _this.showConfirmationBox = true
                _this.prefixString = 'There is no bonus lesson to associate.'
                _this.postString = ' Do you want to add new bonus lesson?'
              }
              if (this.showAssociateMsg) {
                this.showAlertDialog = true
                this.errorMsg = 'In order to add bonus content, you need to fill in following details.'
                // AK: After showing msg set again flag as false in order to not show same msg to user if reopen create bonus element overlay
                this.$emit('showAssociateMsg', false)
              }
            } else {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET BONUS MODULE LIST OPERATION'
        )
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      // AK: If user pressed cancel or X then close given Bonus content creation overlay
      // this.$emit('closeUpdateBonusContentOverlay', false)
    },
    udpateCloseUpdateElementOverlay: function (event) {
      this.$emit('closeUpdateBonusContentOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateBonusContent: function (event) {
      // alert(JSON.stringify(this.elementObj))
      // console.log('updateBonusContent >>>> ' + JSON.stringify(this.elementObj))
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (this.elementObj !== undefined) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          bonusService
            .updateBonusContent(storeObj.state.access_token, _this.elementObj)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Element List by emitting event (ElementList option)
                  _this.$emit('refreshElementList', true)
                  // AK: Hide Update Document overlay
                  _this.$emit('closeUpdateBonusContentOverlay', false)
                } else {
                  // AK: Hide Spinner
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected ElementObj is NULL hence declined CREATE BONUS CONTENT OPERATION'
          )
        }
      }
    },
    setDefaultValues: function () {
      this.elementObj.ModuleId = this.lessonObj.ModuleId
      this.elementObj.ElementId = this.ElementObj.ElementId
      // this.elementObj.Title = this.ElementObj.Title.substr(0, this.ElementObj.Title.indexOf('-'))
      this.elementObj.Title = this.ElementObj.Title
      this.elementObj.Index = this.ElementObj.Index
      this.elementObj.Duration = this.ElementObj.Duration
      this.elementObj.BonusModuleId = this.ElementObj.BonusModuleId === '00000000-0000-0000-0000-000000000000' || this.ElementObj.BonusModuleId === null || this.ElementObj.BonusModuleId === 'null' ? -1 : this.ElementObj.BonusModuleId // this.ElementObj.BonusModuleId
      if (this.ElementObj.BonusModuleId !== '00000000-0000-0000-0000-000000000000' && this.ElementObj.BonusModuleId !== null && this.ElementObj.BonusModuleId !== 'null') {
        this.prevLinkedbonusModuleName = this.ElementObj.Title.slice(this.ElementObj.Title.indexOf('-') + 2, parseInt(this.ElementObj.Title.lastIndexOf(')')))
        this.elementObj.Title = this.ElementObj.Title.substr(0, this.ElementObj.Title.indexOf('-'))
      }
      // console.log('Bonus Update >>>> ' + JSON.stringify(this.ElementObj))
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.BonusTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.elementObj.BonusModuleId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a bonus lesson.'
        return false
      }
      return true
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    BonusTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    BonusIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        var isNonNumeric = /[^$,.\d]/
        var nonNumericResult = newValue.match(isNonNumeric)
        if (!nonNumericResult) {
          this.elementObj.Index = parseInt(newValue)
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Index must be a positive numeric value.'
          this.elementObj.Index = null
        }
      }
    },
    BonusDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    getBonusModuleList: {
      get: function () {
        return this.bonusModuleList
      }
    },
    selectedBonusModuleId: {
      get: function () {
        return this.elementObj.BonusModuleId
      },
      set: function (newValue) {
        this.elementObj.BonusModuleId = newValue
      }
    },
    getIsBonusModuleCreated: {
      get: function () {
        return this.isBonusModuleCreated
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.orange-text-color {
  color: #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateBonusContentElement.vue